import React from 'react'
import type { CSSProperties } from 'react'
import { intl } from 'lang/intl'

import { useWebinarColors } from '../../sharedLegacy/hooks/useWebinarColors'

import Chyron, { ChyronSize } from './chyron'

import './polls-result-chyron.scss'

export interface Options {
  id: number
  option: string
  answerPercentage: number
}

export interface PollResultChyronProps {
  question: string
  options: readonly Options[]
}

const PollResultChyron = ({ question, options }: PollResultChyronProps) => {
  const webinarColor = useWebinarColors()

  const trimmedQuestion = question.trim()
  const questionText =
    trimmedQuestion.length > 240
      ? `${trimmedQuestion.slice(0, 240)}...`
      : trimmedQuestion

  return (
    <Chyron
      size={ChyronSize.Medium}
      kicker={intl.formatMessage({ defaultMessage: 'Poll' })}
    >
      <div
        className="poll-chyron"
        style={
          {
            '--accent-color':
              webinarColor.accent.color === '#FFFFFF'
                ? webinarColor.sidebar.color
                : webinarColor.accent.color,
            '--value-color':
              webinarColor.accent.highContrast.color === '#000000'
                ? '#000000'
                : webinarColor.accent.color,
          } as CSSProperties
        }
      >
        <div className="poll-question">{questionText}</div>
        <div className="poll-results">
          {options.map((item) => (
            <div key={item.id} className="option">
              <span className="answer">{item.option}</span>
              <div className="bar">
                {item.answerPercentage > 0 && (
                  <div
                    className="poll-bar"
                    style={
                      {
                        '--percentage': `${item.answerPercentage * 100}%`,
                      } as CSSProperties
                    }
                  />
                )}
                {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
                <div className="poll">{`${
                  Math.round((item.answerPercentage + Number.EPSILON) * 1000) /
                  10
                }%`}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Chyron>
  )
}

// eslint-disable-next-line import-x/no-default-export
export default PollResultChyron
